<template>
  <div id="shopIndex">
    <div class="header-box">
      <div class="piece-box">
        <div class="icon-box">
          <i class="iconfont icon-zongdingdanliangai header-icon"></i>
        </div>
        <div style="margin-left:12px;">
          <div class="icon-title">今日订单数</div>
          <div>{{info.todayOrderNumber}}</div>
        </div>
      </div>
      <div class="piece-box">
        <div>
          <i class="iconfont icon-jine header-icon"></i>
        </div>
        <div style="margin-left:12px;">
          <div class="icon-title">今日订单金额</div>
          <div>￥{{info.todayOrderMoney}}</div>
        </div>
      </div>
      <div class="piece-box">
        <div>
          <i class="iconfont icon-zongshu header-icon"></i>
        </div>
        <div style="margin-left:12px;">
          <div class="icon-title">订单总数</div>
          <div>{{info.monthOrderNumber}}</div>
        </div>
      </div>
      <div class="piece-box">
        <div>
          <i class="iconfont icon-zongjine header-icon"></i>
        </div>
        <div style="margin-left:12px;">
          <div class="icon-title">订单总金额</div>
          <div>￥{{info.monthOrderMoney}}</div>
        </div>
      </div>
    </div>
    <div class="pending">
      <div class="title">
        <span style="margin-left:16px;">待处理事务</span>
      </div>
      <div class="content-box">
        <div class="content-item" @click="pending('pay')">
          <span>待支付订单</span>
          <span>
            (
            <span style="color:red">{{info.waitPayOrder}}</span> )
          </span>
        </div>
        <div class="content-item" @click="pending('shipment')">
          <span>待发货订单</span>
          <span>
            (
            <span style="color:red">{{info.waitShipmentOrder}}</span> )
          </span>
        </div>
        <div class="content-item" @click="pending('goodslist')">
          <span>待审核商品</span>
          <span>
            (
            <span style="color:red">{{info.waitCheckProduct}}</span> )
          </span>
        </div>
      </div>
    </div>
    <div class="shortcut">
      <div class="title">
        <span style="margin-left:16px;">运营快捷入口</span>
      </div>
      <div class="content-box">
        <div class="content-item">
          <div @click="shortcut('/shop/addgoods')">
            <div>
              <i class="iconfont icon-jia big-icon"></i>
            </div>
            <div>
              <span>添加商品</span>
            </div>
          </div>
        </div>
        <div class="content-item">
          <div @click="shortcut('/shop/goodslist')">
            <div>
              <i class="iconfont icon-zu big-icon"></i>
            </div>
            <div>
              <span>商品列表</span>
            </div>
          </div>
        </div>
        <div class="content-item">
          <div @click="shortcut('order')">
            <div>
              <i class="iconfont icon-list big-icon"></i>
            </div>
            <div>
              <span>订单列表</span>
            </div>
          </div>
        </div>
        <!-- <div class="content-item">
          <div @click="shortcut('shopUi')">
            <div>
              <i class="iconfont icon-meihua big-icon"></i>
            </div>
            <div>
              <span>店铺设置</span>
            </div>
          </div>
        </div> -->
        <div class="content-item">
          <div @click="shortcut('sitemain')">
            <div>
              <i class="iconfont icon-shezhi big-icon"></i>
            </div>
            <div>
              <span>店铺设置</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="pandect">
      <div class="product-pandect">
        <div class="header">
          <span style="margin-left:16px">商品总览</span>
        </div>
        <div class="content">
          <div style="margin-left:10px">
            <div class="big-text">{{info.allProduct}}</div>
            <div class="mini-text">商品总数</div>
          </div>
          <div>
            <div class="big-text">{{info.outCheckProduct}}</div>
            <div class="mini-text">已审核</div>
          </div>
          <div style="margin-right:10px">
            <div class="big-text">{{info.waitCheckProduct}}</div>
            <div class="mini-text">未审核</div>
          </div>
        </div>
      </div>
      <div class="order-pandect">
        <div class="header">
          <span style="margin-left:16px">订单总览</span>
        </div>
        <div class="content">
          <div style="margin-left:10px">
            <div class="big-text">{{info.allOrder}}</div>
            <div class="mini-text">订单总数</div>
          </div>
          <div>
            <div class="big-text">{{info.waitPayOrder}}</div>
            <div class="mini-text">待付款数</div>
          </div>
          <div style="margin-right:10px">
            <div class="big-text">{{info.waitShipmentOrder}}</div>
            <div class="mini-text">待发货数</div>
          </div>
          <div style="margin-right:10px">
            <div class="big-text">{{info.waitSignOrder}}</div>
            <div class="mini-text">待收货数</div>
          </div>
          <div style="margin-right:10px">
            <div class="big-text">{{info.waitCommentOrder}}</div>
            <div class="mini-text">待评价数</div>
          </div>
          <div style="margin-right:10px">
            <div class="big-text">{{info.finishOrder}}</div>
            <div class="mini-text">完成数</div>
          </div>
          <div style="margin-right:10px">
            <div class="big-text">{{info.cancelOrder}}</div>
            <div class="mini-text">取消数</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      serve: this.$store.state.serve,
      token: this.$cookies.get("shop_token"),
      info: "",
    };
  },
  created() {
    this.shopInfo();
    this.$store.state.shop_top = 0;
    this.$store.state.shop_left = "系统首页";
  },
  methods: {
    getPath() {
      window.console.log(this.$route.path);
    },
    shopInfo() {
      var where = {
        token: this.token
      };
      this.axios
        .get(this.serve + "shop/indexInfo", { params: where })
        .then(res => {
          var data = res.data;
          this.info = data;
        });
    },
    shortcut(url) {
      window.console.log(url);
      var pathUrl = "";
      switch (url) {
        case "order":
          pathUrl = "/orderList";
          break;
        case "shopUi":
          pathUrl = "/shopUi";
          break;
        case "sitemain":
          pathUrl = "/sitemain";
          break;
        case "/shop/goodslist":
          pathUrl = "/shop/goodslist";
          break;
        case "/shop/addgoods":
          pathUrl = "/shop/addgoods";
          break;
      }
      let routerJump = this.$router.resolve({ path: pathUrl, query: {} });
      window.open(routerJump.href, "_blank");
    },
    pending(url) {
      var pathUrl = "";
      var status = "";
      switch (url) {
        case "pay":
          pathUrl = "/orderList";
          status = 0;
          break;
        case "shipment":
          pathUrl = "/orderList";
          status = 2;
          break;
        case "goodslist":
          pathUrl = "/shop/goodslist";
          status = 3;
          break;
      }
      let routerJump = this.$router.resolve({
        path: pathUrl,
        query: { status: status }
      });
      window.open(routerJump.href, "_blank");
    }
  }
};
</script>
<style lang="scss">
#shopIndex {
  .header-box {
    display: flex;
    justify-content: space-between;
    .piece-box {
      width: 249px;
      height: 100px;
      background: rgba(255, 255, 255, 1);
      border: 1px solid rgba(221, 221, 221, 1);
      display: flex;
      align-items: center;
      .header-icon {
        margin-left: 16px;
        font-size: 48px;
        color: #0099ff;
      }
      .icon-title {
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: rgba(153, 153, 153, 1);
      }
    }
  }
  .pending {
    margin-top: 31px;
    .title {
      width: 1060px;
      height: 46px;
      background: rgba(238, 238, 238, 1);
      border: 1px solid rgba(221, 221, 221, 1);
      line-height: 46px;
    }
    .content-box {
      width: 1020px;
      height: 60px;
      background: rgba(255, 255, 255, 1);
      border: 1px solid rgba(221, 221, 221, 1);
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 20px 0 20px;
    }
    .content-item {
      padding: 0 10px 5px 10px;
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 300;
      color: rgba(51, 51, 51, 1);
      width: 300px;
      display: flex;
      justify-content: space-between;
      border-bottom: 1px #ccc solid;
    }
    .content-item:hover {
      cursor: pointer;
      color: #0099ff;
    }
  }
  .shortcut {
    margin-top: 31px;
    .title {
      width: 1060px;
      height: 46px;
      background: rgba(238, 238, 238, 1);
      border: 1px solid rgba(221, 221, 221, 1);
      line-height: 46px;
    }
    .content-box {
      width: 1060px;
      height: 164px;
      background: rgba(255, 255, 255, 1);
      border: 1px solid rgba(221, 221, 221, 1);
      display: flex;
      justify-content: space-between;
      color: #999999;
    }
    .content-item {
      width: 212px;
      height: 162px;
      background-color: white;
      display: flex;
      justify-content: center;
      align-items: center;
      border: 1px solid white;
    }
    .content-item:hover {
      cursor: pointer;
      background: rgba(238, 238, 238, 1);
      border: 1px solid rgba(221, 221, 221, 1);
      color: #3498db;
    }
    .big-icon {
      font-size: 66px;
    }
  }
  .pandect {
    margin-top: 31px;
    width: 1062px;
    display: flex;
    justify-content: space-between;
    .product-pandect {
      .header {
        width: 300px;
        height: 46px;
        background: rgba(238, 238, 238, 1);
        border: 1px solid rgba(221, 221, 221, 1);
        line-height: 46px;
      }
      .content {
        width: 300px;
        height: 164px;
        background: rgba(255, 255, 255, 1);
        border: 1px solid rgba(221, 221, 221, 1);
        display: flex;
        justify-content: space-between;
        align-items: center;
        .big-text {
          font-size: 30px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: rgba(246, 78, 98, 1);
          line-height: 2em;
          text-align: center;
        }
        .mini-text {
          line-height: 2em;
        }
      }
    }
    .order-pandect {
      .header {
        line-height: 46px;
        width: 738px;
        height: 46px;
        background: rgba(238, 238, 238, 1);
        border: 1px solid rgba(221, 221, 221, 1);
      }
      .content {
        width: 738px;
        height: 164px;
        background: rgba(255, 255, 255, 1);
        border: 1px solid rgba(221, 221, 221, 1);
        display: flex;
        justify-content: space-between;
        align-items: center;
        .big-text {
          font-size: 30px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: rgba(246, 78, 98, 1);
          line-height: 2em;
          text-align: center;
        }
        .mini-text {
          line-height: 2em;
        }
      }
    }
  }
}
</style>